import { createSelector } from '@reduxjs/toolkit';
import branding from 'shared/app/model/branding';
import { translate_device_icon_state } from 'console/device/icon/transform';
import { select_ui_settings } from 'console/redux/settings-actions';
import { selectDevice, selectDevices, selectDevicesFields, selectSelectedDevice, } from 'entities/device/lib';
import { LegacyDevice } from 'console/device/device';
export const selectAccount = (state) => state.account;
const sortFilteredDevices = (devices) => devices.map((dev) => ({ id: dev.id, name: LegacyDevice.display_name(dev) }));
export const select_filtered_devices = createSelector(selectDevicesFields(['id', 'name', 'individual_device_name']), sortFilteredDevices);
const _select_device_type_name = (state) => selectSelectedDevice(state)?.device_type?.name;
export const select_device_type_name = createSelector(_select_device_type_name, (name) => name != null ? name.replace('ZONT', branding.name.replace('Connect', '')) : name);
export const devices_for_tree = createSelector(selectDevicesFields([
    'id',
    'name',
    'device_type',
    'sim_in_device',
    'access',
    'serial',
    'owner_username',
    'user_id',
    'iconState',
    'individual_device_name',
    'individual_device_note',
    'visible_device_type',
    'capabilities',
]), (devices) => devices.map((dev) => ({
    ...dev,
    translate_state: translate_device_icon_state[dev.iconState],
})));
export const select_selected_devices_tree_filters = (state) => {
    return select_ui_settings(state)?.devices_state_filters;
};
function filterDevicesForState(state_filters, devices) {
    const _state_filters = state_filters ?? [];
    if (_state_filters.length > 0) {
        return devices.filter((device) => _state_filters.some((state) => state === device.iconState));
    }
    return devices;
}
export const select_devices_filtered_by_state = createSelector(select_selected_devices_tree_filters, devices_for_tree, (state_filters, devices) => filterDevicesForState(state_filters, devices));
export function select_device_by_appliance_type(state, appliance_type) {
    const devices = selectDevices(state);
    for (const dev of devices) {
        if (appliance_type.includes(dev.appliance_type)) {
            return dev;
        }
    }
    return null;
}
export const select_current_account_id = (state) => {
    return state.account.id;
};
export function selector_archive_tasks(state) {
    return state.alien_services.archive_tasks;
}
export function selector_alien_tokens(state) {
    return state.alien_services.alien_tokens;
}
export function selector_alien_app_urls(state) {
    return state.alien_app_urls;
}
export const select_device_capabilities = createSelector((state, device_id) => selectDevices(state).find((device) => device.id === device_id), (device) => (device != null ? device.capabilities : null));
export const selectZ3KState = (state) => selectSelectedDevice(state)?.z3k_state;
export const selectCurrentDeviceName = createSelector(selectDevice, (device) => device != null ? LegacyDevice.display_name(device) : null);
